import { render, staticRenderFns } from "./AgreementsTable.vue?vue&type=template&id=3b38609e&"
import script from "./AgreementsTable.vue?vue&type=script&lang=js&"
export * from "./AgreementsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports